import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import api from '../../../../services/api';

const formatCurrencyBR = (value) => {
    const number = Number(value);
    if (Number.isNaN(number)) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(number);
};

const StatCard = ({ label, value }) => (
    <Card>
        <CardContent>
            <Typography variant="caption" color="text.secondary">
                {label}
            </Typography>
            <Typography variant="h5">{value}</Typography>
        </CardContent>
    </Card>
);

const InventoryValuationReport = () => {
    const [appId, setAppId] = useState(null);
    const [data, setData] = useState(null);

    useEffect(() => {
        (async () => {
            const res = await api.get('v1/apps/default/');
            setAppId(res.data.app.id);
        })();
    }, []);

    useEffect(() => {
        if (!appId) return;
        (async () => {
            const res = await api.get(`v1/apps/${appId}/reports/inventory/valuation/`);
            setData(res.data);
        })();
    }, [appId]);

    if (!data) return null;

    return (
        <Box p={{ xs: 2, md: 4 }}>
            <Typography variant="h4" fontWeight="700" mb={1}>
                Estoque Valorizado
            </Typography>
            <Typography variant="body2" color="text.secondary" mb={4}>
                Valor do estoque atual, em custo e em potencial de venda
            </Typography>

            <Grid container spacing={2} mb={3}>
                <Grid item xs={12} sm={4}>
                    <StatCard label="Valor em custo" value={formatCurrencyBR(data.total_custo)} />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <StatCard label="Potencial de venda" value={formatCurrencyBR(data.total_venda_potencial)} />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <StatCard label="Margem potencial" value={formatCurrencyBR(data.margem_potencial)} />
                </Grid>
            </Grid>

            <Card>
                <CardContent>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Produto</TableCell>
                                <TableCell>Variação</TableCell>
                                <TableCell align="right">Estoque</TableCell>
                                <TableCell align="right">Custo unit.</TableCell>
                                <TableCell align="right">Custo total</TableCell>
                                <TableCell align="right">Venda total</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.rows.map((row) => (
                                <TableRow key={row.produto_variacao}>
                                    <TableCell>{row.produto}</TableCell>
                                    <TableCell>{row.variacao}</TableCell>
                                    <TableCell align="right">{row.estoque}</TableCell>
                                    <TableCell align="right">{formatCurrencyBR(row.valor_custo_unitario)}</TableCell>
                                    <TableCell align="right">{formatCurrencyBR(row.custo_total)}</TableCell>
                                    <TableCell align="right">{formatCurrencyBR(row.valor_venda_total)}</TableCell>
                                </TableRow>
                            ))}
                            {data.rows.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={6} align="center">
                                        Nenhuma variação de produto cadastrada
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </CardContent>
            </Card>
        </Box>
    );
};

export default InventoryValuationReport;
